import { useEffect, useRef } from 'react'
import classes from './Transcript.module.css'
import MarkdownView from 'react-showdown';
import { useSelector } from 'react-redux';
import ChatStateMachine from './stateMachine/ChatStateMachine';

function Transcript() {
    const chatState = useSelector(state => state.chat)
    const bottomOfTheChatRef = useRef()

    useEffect(() => {
        if (bottomOfTheChatRef && bottomOfTheChatRef.current) {
            bottomOfTheChatRef.current.scrollIntoView({ behavior: "smooth" });
        }
    },[chatState.transcript, chatState.stateMachine])

    let disableStateMachin = false;
    if (chatState.transcript.length > 0) {
        disableStateMachin = true
    }
    let chat = (
        <div className={classes.Transcript}>
            <ChatStateMachine disabled={disableStateMachin}/>
            <div ref={bottomOfTheChatRef}/>
        </div>
    )
    if (chatState.id != null) {
        const bubbles = chatState.transcript.map((m,i) => {
            let senderPrefix = "User"
            if (m.sender === "MODEL" || m.sender === "SYSTEM") {
                senderPrefix = "Model"
            }
            return (
                <div key={i} className={classes[`${senderPrefix}BubbleContainer`]}>
                    <div className={classes[`${senderPrefix}Bubble`]}>
                        <MarkdownView 
                            markdown={m.text}
                            options={{ tables: true, emoji: true }}
                        />
                    </div>
                </div>
            )
        })
    
    
    
        let loader = null
        if (chatState.pendingResponse) {
            loader = <div className={classes.Loader}/>
        }
        chat = (
            <div className={classes.Transcript}>
                <ChatStateMachine disabled={disableStateMachin}/>
                {bubbles}
                {loader}
                <div ref={bottomOfTheChatRef}/>
            </div>
        )
    }

    return (
        <>
            {chat}
        </>
    );
}

export default Transcript;
